import React, { Component } from 'react';
import { NumberInput } from '../components/NumberInput.tsx';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { LenderRow } from '../components/LenderRow.tsx';

interface IProps {
    gtmEvent(): void;
    nextStep(): void;
    prevStep(): void;
    // setHomeValue(v: any): void;
    // setExistingMortgage(v: any): void;
    updateLead(props: any): void;
    homeValue?: number;
    existingMortgage?: number;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    homeValue?: number;
    existingMortgage?: number;
}

export class SwitcherValues extends Component<IProps, IState> {
    
    componentDidMount(): void {
        this.props.gtmEvent();
    }

    constructor (props: IProps) {
        super(props);
        this.state = {hasError: false, homeValue: this.props.homeValue, existingMortgage: this.props.existingMortgage};
    }

    nextStep() {
        if (!this.state.homeValue || !this.state.existingMortgage) {
            var errors:string[]=[];
            if (!this.state.homeValue) {
                errors.push("Approximate Home Value is required");
            }
            if (!this.state.existingMortgage) {
                errors.push("Outstanding Mortgage Balance is required");
            }
            this.setState({errors: errors, hasError: true});
            return;
        }

        if (this.state.existingMortgage / this.state.homeValue > 0.9) {
            var errors: string[] = [];
            errors.push("Mortgage amount required cannot be greater than 90% of the home value")
            //this.setState({errors: errors, hasError: true, existingMortgage: Math.round(this.state.homeValue * 0.9)});
            this.setState({errors: errors, hasError: true});
            return;
        }

        this.props.nextStep();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'>Let's compare what you have,<br/>with what's out there</h1>
                <p>Just 4 quick questions about your home and current mortgage</p>
                <div className='wrapper'>
                    <div className='row'>
                        <div className='column2 justify-e'>
                            <NumberInput
                                id='homeValue'
                                key='homeValue'
                                label={<>Approximate <strong>Home Value</strong></>}
                                value={this.props.homeValue}
                                classes={this.state.hasError && !this.state.homeValue ? "e" : ""}
                                onChange={(e) => {  this.setState({homeValue: e.target.value}); this.props.updateLead({homeValue: e.target.value}); }} />
                        </div>
                        <div className='column2 justify-s'>
                            <NumberInput
                                id='mortgagevalue'
                                key='mortgagevalue'
                                label={<>Outstanding <strong>Mortgage Balance</strong></>}
                                value={this.props.existingMortgage}
                                classes={this.state.hasError && !this.state.existingMortgage ? "e" : ""}
                                onChange={(e) => { this.setState({existingMortgage: e.target.value}); this.props.updateLead({existingMortgage: e.target.value}); }} />
                        </div>
                    </div>
                    {this.state.hasError &&
                        <ErrorBox errors={this.state.errors!} />
                    }
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton onClick={() => this.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>
                </div>
            </header>
        );
    }
}
